<template>
  <div>
    <nav v-if="breadcrumb" class="border-b border-gray-300 py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'customers'}">Service Plans</router-link>
          </div>
          <div class="text-xl text-primary">
            Service Plans
          </div>
        </div>
        <div class="">
          <div class="inline-block relative float-right">
            <router-link :to="{name:'create_service_plan'}"
                         style="color: white !important;" v-if="$store.getters.can('create_service_plan')"
                         class="bg-teal-500 text-white hover:bg-teal-700 py-2 px-4 rounded-sm inline-flex items-center">
              New plan
            </router-link>
          </div>
        </div>
      </div>
    </nav>
    <div class="pb-4">
      <div class="bg-white pt-3 border rounded shadow-sm">
        <div class="font-semibold mx-2 text-gray-600">{{ title }}</div>
        <div class="flex justify-between pt-2 px-3">
          <div>
            <label class="block tracking-wide text-gray-700">Records</label>
            <select v-model="recordsPerPage" @change="loadStats(currentPage)"
                    class="block appearance-none w-full bg-white border border-gray-300  px-4 py-2  rounded leading-tight focus:outline-none focus:border-gray-500">
              <option>5</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>250</option>
            </select>
          </div>
          <div>
            <label class="block tracking-wide text-gray-700">Search</label>
            <input v-model="searchString" @change="loadStats(currentPage)"
                   class="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500"
                   type="text" placeholder="Search">
          </div>
        </div>
        <div class=" overflow-auto ">
          <table v-if="!loading" class="table-auto w-full">
            <thead>
            <tr class="border-b font-bold">
              <td class="px-4 py-2"></td>
              <td class="px-4 py-2">Plan Name</td>
              <td class="px-4 py-2">Code</td>
              <td class="px-4 py-2">Bandwidth Policy</td>
              <td class="px-4 py-2">Time Limit</td>
              <td class="px-4 py-2">Data Limit</td>
              <td class="px-4 py-2">Validity</td>
              <td class="px-4 py-2">Simultaneous connections</td>
              <td class="px-4 py-2">Price</td>
              <td class="px-4 py-2">Subscriptions</td>
              <td class="px-4 py-2">Description</td>
            </tr>
            </thead>
            <tbody>
            <tr class="border-b" v-for="(plan,index) in servicePlans" :key="plan.id">
              <td class="px-4 py-2">{{ index + 1 }}</td>
              <td class="px-4 py-2">
                <router-link :to="{name:'service_plan', params:{planId: plan.id}}">
                  {{ plan.name }}
                </router-link>
              </td>
              <td class="px-4 py-2">{{ plan.code }}</td>
              <td class="px-4 py-2">
                <router-link v-if="plan.bandwidthPolicy.id !== ''" :to="{name:'bandwidth_policy', params:{policyId: plan.bandwidthPolicy.id}}">
                  {{ plan.bandwidthPolicy.name }}
                </router-link>
                <div v-else class="font-bold text-gray-500">{{ plan.bandwidthPolicy.name }}</div>
              </td>
              <td class="px-4 py-2">{{ plan.time_limit }} {{ plan.time_limit_unit }}</td>
              <td class="px-4 py-2">{{ plan.usage_limit }} {{ plan.usage_limit_unit }}</td>
              <td class="px-4 py-2">{{ plan.validity + " " + plan.validity_units }}</td>
              <td class="px-4 py-2">{{ plan.simultaneous_connections }}</td>
              <td class="px-4 py-2">Kes {{ plan.price }}</td>
              <td class="px-4 py-2">{{ plan.subscriptions }}</td>
              <td class="px-4 py-2">{{ plan.description }}</td>
            </tr>
            </tbody>
          </table>

          <div v-else class="py-6 text-center w-full">
            <feather animation="spin" type="loader" size="32" class="mr-4"></feather>
            <p>Loading...</p>
          </div>
          <Pagination class="py-2 px-3" :total-count="servicePlansCount" :current-page="currentPage"
                      :tag="'connections'" :offset="offset"
                      :records-count="servicePlans != null ? servicePlans.length || 0 : 0"
                      :click-handler="loadStats" :records-per-page="parseInt(recordsPerPage)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import GraphQl from "@/services/graphql.service";

export default {
  name: "ServicePlans",
  components: {Pagination},
  data() {
    return {
      searchString: '',
      recordsPerPage: this.rowsPerPage,
      servicePlansCount: 0,
      servicePlans: [],
      currentPage: 1,
      loading: true
    }
  },
  props: {
    title: {type: String, default: 'Service plans'},
    configs: Object,
    rowsPerPage: {type: Number, default: 10},
    breadcrumb: {default: true, type: Boolean}
  },
  mounted() {
    this.loadStats();
  },

  computed: {
    offset: function () {
      return (this.currentPage - 1) * this.recordsPerPage;
    }
  },
  watch: {
    searchString: function () {
      this.currentPage = 1;
    }
  },
  methods: {
    loadStats(newPage) {
      this.currentPage = newPage || 1;
      this.loading = true

      let params = 'limit: ' + this.recordsPerPage + ', ' +
          'offset: ' + this.offset + ', ' +
          'order: "created_at desc", ' +
          'search: "' + this.searchString + '"';
      GraphQl.sendRequest(
          ' {servicePlansCount(' + params + ') servicePlans(' + params + ')' +
          '   {id name bandwidthPolicy{id name} description code time_limit time_limit_unit usage_limit usage_limit_unit simultaneous_connections validity validity_units price}' +
          ' }')
          .then(response => {
            this.servicePlans = response.servicePlans;
            this.servicePlansCount = response.servicePlansCount;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>

</style>